import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        suppliers: false
      },
      options: {
        suppliers: []
      },
      selected: {
        supplier: ''
      },
      editable: {
        supplier: ''
      }
    }
  },

  methods: {

    async getSuppliers (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.supplier
      const fetching = context.fetching?.suppliers
      const options = context.options?.suppliers

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.suppliers = true
      context.selected.supplier = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getSuppliers(filters).then(
        ({ data }) => {
          context.options.suppliers = data
          return data
        }
      ).catch(() => {
        context.options.suppliers = []
        return []
      }).finally(() => {
        context.fetching.suppliers = false
      })
    },

    async searchSuppliers (search, loading) {
      this.searchSuppliersProvider(this, search, loading)
    },

    searchSuppliersProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.suppliers, {
          keys: ['supplier_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getSuppliers(filters).then(
            ({ data }) => {
              options.suppliers = data
            }
          ).catch(() => {
            options.suppliers = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
